import { useState, useEffect } from 'react';
import "../../styles/StudentPlacementHistory.css";
import CompanyDetailsModal from "../Notifications/CompanyDetailsModal";

const StudentPlacementHistory = ({ studentId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [selectedMappingId, setSelectedMappingId] = useState(null);

  useEffect(() => {
    if (!studentId) {
      setLoading(false);
      return;
    }
    fetchHistory();
  }, [studentId]);

  const fetchHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Student-history/${studentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = await response.json();
      if (data.success) setHistory(data.data || []);
    } catch (err) {
      setError("Failed to load placement history");
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      "Assigned": "status-assigned",
      "Cancelled": "status-cancelled",
      "Selected": "status-selected",
      "Not Selected": "status-not-selected",
      "Rejected By Student": "status-rejected-student",
      "Accepted the Offer": "status-accepted",
      "Rejected the Offer": "status-rejected-offer",
      "Acknowledged": "status-acknowledged",
      "Shortlisted": "status-shortlisted",
      "Interview Scheduled": "status-interview-scheduled",
      "Resume Not Shortlisted": "status-resume-not-shortlisted",
    };

    return statusMap[status] || "status-default";
  };


  const formatDate = (dateString) => {
    if (!dateString) return "Not Set";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const toggleExpandRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  if (loading) return <div className="loading-container">Loading...</div>;
  if (error) return <div className="error-text">{error}</div>;
  if (!studentId) return <div className="empty-container">No student selected</div>;
  if (history.length === 0)
    return <div className="empty-container">No placement history found</div>;

  return (
    <div className="ph-container">
      <div className="ph-header">
        <h3 className="ph-title">Placement History</h3>
        <span className="ph-badge">{history.length} Companies</span>
      </div>

      <div className="ph-table-wrapper">
        <table className="ph-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Company ID</th>
              <th>Company</th>
              <th>Acknowledged Date</th>
              <th>Created On</th>
              <th>Status & Feedback</th>
            </tr>
          </thead>


          <tbody>
            {history.map((item, index) => (
              <>
                <tr key={item.id} className="ph-row">
                  <td>{index + 1}</td>
                  <td>
                    <span
                      style={{
                        color: "#2563eb",
                        cursor: "pointer",
                        fontWeight: 600,
                        textDecoration: "underline"
                      }}
                      onClick={() => setSelectedMappingId(item.id)}
                      title="Click to view company details"
                    >
                      {item.companyId}
                    </span>
                  </td>
                  <td>
                    <strong>{item.companyName}</strong>
                    {item.jobRole && <div className="sub-text">{item.jobRole}</div>}
                  </td>

                  <td>
                    {item.acknowledgementDate
                      ? formatDate(item.acknowledgementDate)
                      : <span className="not-acknowledged">Not Responded</span>}
                  </td>

                  <td>{formatDate(item.createdAt)}</td>

                  <td>
                    {(() => {
                      const displayStatus = item.acknowledgementStatus || item.currentStatus;

                      return (
                        <>
                          <span className={`status-badge ${getStatusBadgeClass(displayStatus)}`}>
                            {displayStatus || "Pending"}
                          </span>

                          {item.feedback && (
                            <div className="inline-feedback">{item.feedback}</div>
                          )}
                        </>
                      );
                    })()}
                  </td>
                </tr>


                {/* EXPANDED DETAILS */}
                {expandedRow === item.id && (
                  <tr className="expanded-row">
                    <td colSpan="6">
                      <div className="details-box">
                        <div className="details-grid">
                          <div>
                            <strong>Applied On:</strong> {formatDate(item.createdAt)}
                          </div>

                          {item.location && (
                            <div>
                              <strong>Location:</strong> {item.location}
                            </div>
                          )}

                          {item.package && (
                            <div>
                              <strong>Package:</strong> {item.package} LPA
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>
      {selectedMappingId && (
        <CompanyDetailsModal
          mappingId={selectedMappingId}
          onClose={() => setSelectedMappingId(null)}
          onAcknowledged={fetchHistory}
        />
      )}
    </div>
  );
};

export default StudentPlacementHistory;
